<!--note that this uses a variable background color, may want to change for a specific one from this component alone-->
<ion-content class="content-theme-one">
  <!--top bar-->
  <div class="sectionContainer">
    <!-- simply add the ActiveCat scss if a specific selection i active -->
    <!--<button class="sectionSelector ActiveCat">{{ 'MessagePage.TitleTab'  | translate }}</button>-->
    <!--<button class="sectionSelector">{{ 'MessagePage.TitleTab'  | translate }}</button>-->
    <button class="sectionSelector">{{ 'MessagePage.TitleTabNotif'  | translate }}</button>
  </div>

  <!-- main content -->
  <div class="messagesDisplayer">

    <!-- news -->
    @for(category of newsCategories; track category) {
      @for(news of category.news; track news) {
        <div class="message" (click)="showmorenews(news)">
          <div class="message_img">
            @if (news.images.imgURL) {
              <div class="message_img_innercontainer">
                  <img class="imgs" [src]="getnewsImage(news)">
              </div>
            }
            <!--
            @if (newsblog.images.imgMobileURL && this.mobile) {
              <img class="imgs" [src]="getpromoImage(promotion)">
            }
              -->
          </div>
          <div class="message_content">
            <div class="message_content_title">
              {{ news.title.translations[translationService.getLanguage()] }}
            </div>
            <div class="message_content_description" [innerHTML]="news.shortDescription.translations[translationService.getLanguage()]">
              <!--{{ news.shortDescription.translations[translationService.getLanguage()] }}-->
            </div>
            
            <!--
            <div class="message_content_options">
              <button class="message_content_options_button" (click)="showmorenews(news)">{{ 'MessagePage.ShowMore'  | translate }}</button>
              @if (this.authservice.isAuthenticated) {
                <button class="message_content_options_button_delete" (click)="deletenews(news)">{{ 'MessagePage.Delete'  | translate }}</button> 
              }
            </div>
            -->
          </div>
        </div>
      }
    }

    <!-- blogs -->
    @for(category of blogsCategories; track category) {
      @for(blog of category.blogs; track blog) {
        <div class="message" (click)="showmoreblog(blog)">
          <div class="message_img">
            @if (blog.images.imgURL) {
              <div class="message_img_innercontainer">
                  <img class="imgs" [src]="getblogsImage(blog)">
              </div>
            }
            <!--
            @if (newsblog.images.imgMobileURL && this.mobile) {
              <img class="imgs" [src]="getpromoImage(promotion)">
            }
              -->
          </div>
          <div class="message_content">
            <div class="message_content_title">
              {{ blog.title.translations[translationService.getLanguage()] }}
            </div>
            <div class="message_content_description" [innerHTML]="blog.shortDescription.translations[translationService.getLanguage()]">
              <!--{{ blog.shortDescription.translations[translationService.getLanguage()] }}-->
            </div>

            <!--
            <div class="message_content_options">
              <button class="message_content_options_button" (click)="showmoreblog(blog)">{{ 'MessagePage.ShowMore'  | translate }}</button>
              @if (this.authservice.isAuthenticated) {
                <button class="message_content_options_button_delete" (click)="deleteblogs(blog)">{{ 'MessagePage.Delete'  | translate }}</button> 
              }
            </div>
            -->
          </div>
        </div>
      }
    }
    

    @if (this.authservice.isAuthenticated) {
      <div class="additionalOptions">
        <button class="option" (click)="deleteall()">
          <!--{{ "translation.deletall" | translate }}-->
          {{ 'MessagePage.DeleteAll'  | translate }}
        </button>
      </div>
    }
    
  </div>








  <app-undocked-navigation-bar style="z-index: 10;"></app-undocked-navigation-bar>

</ion-content>
